import {docSystemTypesDefaultModelsList} from '../../types/document/types'

export const getDocumentSectionsRoutes = ({defaultComponent, sidebarComponent}) => {
    return docSystemTypesDefaultModelsList
        .map(section => ({
            path: `/app/:team/${section.route}`,
            name: section.route,
            components: {default: defaultComponent, sidebar: sidebarComponent},
            props: {default: true, sidebar: false},
            children: [
                {
                    name: `${section.route}.view`,
                    path: `/app/:team/${section.route}/:docUuid`
                }
            ]
        }))
}
